export const TITLE_KEYWORD_MAP: Record<string, string> = {
  // English keywords
  'rules-to-evidence workflow': 'COMP_EST',
  workflow: 'COMP_EST',
  'audit findings': 'AUDIT_FINDINGS',
  audit_en: 'AUDIT_FINDINGS',
  'business process & risk control hub': 'INTERNAL_CONTROLS',
  'risk control': 'INTERNAL_CONTROLS',
  'identity access management': 'USER_ACCESS',
  'user access': 'USER_ACCESS',
  'data management': 'DATA_MANAGEMENT',
  'who am i': 'WHO_AM_I',
  library: 'LIBRARY',
  library_en: 'LIBRARY',
  reporting: 'REPORTING',
  reporting_en: 'REPORTING',

  // Dependency Tree
  'dependency tree': 'DEPENDENCY_TREE',
  dependency_tree: 'DEPENDENCY_TREE',
  'dependency-tree': 'DEPENDENCY_TREE',
  dependency: 'DEPENDENCY_TREE',

  // German keywords
  'regeln zu nachweisen workflow': 'COMP_EST',
  'workflow von regeln zu nachweisen': 'COMP_EST',
  prüfungsfeststellungen: 'AUDIT_FINDINGS',
  prüfung: 'AUDIT_FINDINGS',
  'steuerung und risikozuweisung': 'INTERNAL_CONTROLS',
  steuerung: 'INTERNAL_CONTROLS',
  benutzerzugriff: 'USER_ACCESS',
  datenverwaltung: 'DATA_MANAGEMENT',
  bibliothek: 'LIBRARY',
  berichterstattung: 'REPORTING',

  // Dependency Tree DE
  abhängigkeitsbaum: 'DEPENDENCY_TREE',
  abhängigkeitsstruktur: 'DEPENDENCY_TREE',
  'dependency baum': 'DEPENDENCY_TREE',

  // French keywords
  'flux de travail des règles aux preuves': 'COMP_EST',
  'flux de travail': 'COMP_EST',
  "constatations d'audit": 'AUDIT_FINDINGS',
  constat: 'AUDIT_FINDINGS',
  'contrôles et allocation des risques': 'INTERNAL_CONTROLS',
  contrôles: 'INTERNAL_CONTROLS',
  'accès utilisateur': 'USER_ACCESS',
  'gestion des données': 'DATA_MANAGEMENT',
  bibliothèque: 'LIBRARY',
  rapports: 'REPORTING',

  // Dependency Tree FR
  'arbre de dépendance': 'DEPENDENCY_TREE',
  'arbre des dépendances': 'DEPENDENCY_TREE',
  dépendance: 'DEPENDENCY_TREE',

  // Spanish keywords
  'flujo de trabajo de reglas a evidencias': 'COMP_EST',
  'flujo de trabajo': 'COMP_EST',
  'hallazgos de auditoría': 'AUDIT_FINDINGS',
  auditoría: 'AUDIT_FINDINGS',
  'controles y asignación de riesgos': 'INTERNAL_CONTROLS',
  controles_es: 'INTERNAL_CONTROLS',
  'acceso de usuario': 'USER_ACCESS',
  'gestión de datos': 'DATA_MANAGEMENT',
  biblioteca_es: 'LIBRARY',
  informes: 'REPORTING',

  // Dependency Tree ES
  'árbol de dependencias': 'DEPENDENCY_TREE',
  'estructura de dependencias': 'DEPENDENCY_TREE',
  dependencia: 'DEPENDENCY_TREE',

  // Italian keywords
  'flusso di lavoro dalle regole alle evidenze': 'COMP_EST',
  'flusso di lavoro': 'COMP_EST',
  'risultati di audit': 'AUDIT_FINDINGS',
  audit_it: 'AUDIT_FINDINGS',
  'controlli e allocazione del rischio': 'INTERNAL_CONTROLS',
  controlli: 'INTERNAL_CONTROLS',
  'accesso utente': 'USER_ACCESS',
  'gestione dati': 'DATA_MANAGEMENT',
  biblioteca_it: 'LIBRARY',
  segnalazione: 'REPORTING',

  // Dependency Tree IT
  'albero delle dipendenze': 'DEPENDENCY_TREE',
  'struttura delle dipendenze': 'DEPENDENCY_TREE',
  dipendenza: 'DEPENDENCY_TREE',

  // Portuguese keywords
  'fluxo de trabalho de regras para evidências': 'COMP_EST',
  'fluxo de trabalho': 'COMP_EST',
  'descobertas de auditoria': 'AUDIT_FINDINGS',
  auditoria: 'AUDIT_FINDINGS',
  'controles e alocação de riscos': 'INTERNAL_CONTROLS',
  controles_pt: 'INTERNAL_CONTROLS',
  'acesso do usuário': 'USER_ACCESS',
  'gestão de dados': 'DATA_MANAGEMENT',
  biblioteca_pt: 'LIBRARY',
  relatórios: 'REPORTING',

  // Dependency Tree PT
  'árvore de dependências': 'DEPENDENCY_TREE',
  'estrutura de dependências': 'DEPENDENCY_TREE',
  dependência: 'DEPENDENCY_TREE'
};
